// import { hpHttpClient } from 'root/api/http';
import { hpGqlClient } from 'root/api/';
import { crudActions } from 'root/store/helpers';
import { GuidelineQuery } from './query';

const { create, filter, fetchMany, getById, update, deleteById, upsert } = hpGqlClient.guideline;

export const actions = {
  ...crudActions('guideline', {
    create, filter, fetchMany, getById, update, deleteById, upsert
  }, {
    queries: GuidelineQuery,
  }),
};
